'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 10px;\n  color: ", ";\n  font-size: ", ";\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: ", ";\n  ", ";\n  ", ";\n"], ["\n  display: block;\n  margin-bottom: 10px;\n  color: ", ";\n  font-size: ", ";\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: ", ";\n  ", ";\n  ", ";\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: block;\n  margin-top: 3px;\n  color: ", ";\n  font-size: ", ";\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: ", ";\n  ", ";\n"], ["\n  display: block;\n  margin-top: 3px;\n  color: ", ";\n  font-size: ", ";\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: ", ";\n  ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  border-style: none;\n  cursor: pointer;\n  ", ";\n  &:focus {\n    outline: none;\n  }\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-size: 14px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  border-style: none;\n  cursor: pointer;\n  ", ";\n  &:focus {\n    outline: none;\n  }\n  &:hover {\n    color: ", ";\n  }\n"]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n  position: relative;\n"], ["\n  position: relative;\n"]);

var StyledLabel = styled__default.label(_templateObject, function (props) {
  return props.textColor ? "" + props.textColor : "" + settings.COLOR.textBlack;
}, function (props) {
  return props.size ? "" + props.size : "16px";
}, function (props) {
  return props.weight ? "" + props.weight : "normal";
}, function (props) {
  return props.disabled && "color: " + settings.COLOR.lightGray;
}, function (props) {
  return props.labelStyle;
});
var ErrorMessage = styled__default.label(_templateObject2, settings.COLOR.softRed, function (props) {
  return props.size ? "" + props.size : "16px";
}, function (props) {
  return props.weight ? "" + props.weight : "normal";
}, function (props) {
  return props.ErrorMessageStyle;
});
var RedText = styled__default.span(_templateObject3, settings.COLOR.softRed, function (props) {
  return props.disabled && "color: " + settings.COLOR.lineGray;
});

var Wrapper = styled__default.div(_templateObject4, function (props) {
  return props.margin && "margin: " + props.margin;
});

var InputGroup = styled__default.div(_templateObject5, function (props) {
  return props.mb ? props.mb + "px" : "10px";
});

var ShowPwBtn = styled__default.button(_templateObject6, settings.COLOR.lightGray, function (props) {
  return props.disabled && "\n    color: " + settings.COLOR.lineGray + "\n    pointer-events: none\n  ";
}, settings.COLOR.gray);

var Div = styled__default.div(_templateObject7);

exports.Div = Div;
exports.ErrorMessage = ErrorMessage;
exports.InputGroup = InputGroup;
exports.RedText = RedText;
exports.ShowPwBtn = ShowPwBtn;
exports.StyledLabel = StyledLabel;
exports.Wrapper = Wrapper;
//# sourceMappingURL=shared-components.js.map
